import { render, staticRenderFns } from "./CredenciamentoFornecedorAcoesReenviarDocumentos.vue?vue&type=template&id=24ec1921"
import script from "./CredenciamentoFornecedorAcoesReenviarDocumentos.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorAcoesReenviarDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorAcoesReenviarDocumentos.vue?vue&type=style&index=0&id=24ec1921&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports